import *  as types from "../../../databse/types";

const initialState = {
    show: false,
    loader: false,
    destination: '',
    fromEditOrder: false,
};
const modalChangeAddress = (state = initialState, action) => {
    switch (action.type) {
        case types.MODAL_CHANGE_ADDRESS_CHANGE_SHOW:
            return action.destination !== undefined
                ? {...state, show: action.show, destination: action.destination, fromEditOrder: action.fromEditOrder}
                : {...state, show: action.show, fromEditOrder: action.fromEditOrder};
        case types.MODAL_CHANGE_ADDRESS_CHANGE_LOADER:
            return {...state, loader: action.loader};
        default:
            return state;
    }
};

export default modalChangeAddress;
